module.exports = __webpack_public_path__ + "img/tune.54fba865.svg";